// https://github.com/mzabriskie/axios
import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router/index'
//cookie
const cookie = require('vue-cookie')
import Qs from 'qs'
//自定义公用模块
import utils from '@/assets/js/utils'
axios.defaults.withCredentials = true
axios.defaults.retry = 0 //重试次数
axios.defaults.retryDelay = 2000 //重试延时
axios.defaults.shouldRetry = (error) => true //重试条件，默认只要是错误都需要重试
axios.defaults.transformRequest = [function (data) {

  let returnData = Qs.stringify(data)
  return returnData == "" ? data : returnData
}];
// 拦截request,设置全局请求为ajax请求
axios.interceptors.request.use((config) => {
	config.headers['X-Requested-With'] = 'XMLHttpRequest'
	//config.headers.authorization = 'xxxx'
	return config
})
// 拦截响应response，并做一些错误处理
axios.interceptors.response.use((response) => {
	//console.log("拦截器地址", response.config.url)
	const data = response.data
	const toast = Toast.loading({
		duration: 0, // 持续展示 toast
		mask: true,
		message: 'Loading'
	})
	//console.log("拦截器",data.status)
	if(data) {
		let second = 1
		const timer = setInterval(() => {
			second--
			if(second) {

			} else {
				clearInterval(timer)
				Toast.clear()
			}
		}, 500)
	}
	return data
	// 若不是正确的返回code，且已经登录，就抛出错误
	const err = new Error(data.description)
	err.data = data
	err.response = response
	throw err
}, (err) => { // 这里是返回状态码不为200时候的错误处理
	if(err && err.response) {
		if(err.response.status == 401) {
			//前端缓存失效，清除缓存内容，重新登录
      setTimeout(()=>{
        cookie.delete('NEO_TOKEN', {
          domain: ".brand.hkxdjy.com"
        })
        cookie.delete('NEO_TOKEN', {
          domain: ".natapp1.cc"
        })
        cookie.delete('NEO_TOKEN', {
          domain: utils.curDomain()
        })
        utils.clearAllCookie()

      },500)
      setTimeout(()=>{
      window.location.reload()
      },1000)
			// router.push({
			// 	path: '/',
			// 	name: 'index',
			// })
		}
		switch(err.response.status) {
			case 400:
				err.message = '用户不存在,或密码错误'
				break
			case 401:
				err.message = '加载中'
				break
			case 403:
				err.message = '拒绝访问'
				break
			case 404:
				err.message = `请求地址出错: ${err.response.config.url}`
				break
			case 408:
				err.message = '请求超时'
				break
			case 500:
				err.message = '服务器内部错误'
				break
			case 501:
				err.message = '服务未实现'
				break
			case 502:
				err.message = '网关错误'
				break
			case 503:
				err.message = '服务不可用'
				break
			case 504:
				err.message = '网关超时'
				break
			case 505:
				err.message = 'HTTP版本不受支持'
				break
			default:
		}
	}

	Toast(err.message)

	return Promise.reject(err)
})

//失败重新加载接口
axios.interceptors.response.use(undefined, (err) => {
	var config = err.config
	// 判断是否配置了重试
	if(!config || !config.retry) return Promise.reject(err)
	if(!config.shouldRetry || typeof config.shouldRetry != 'function') {
		return Promise.reject(err)
	}
	//判断是否满足重试条件
	if(!config.shouldRetry(err)) {
		return Promise.reject(err)
	}
	// 设置重置次数，默认为0
	config.__retryCount = config.__retryCount || 0
	// 判断是否超过了重试次数
	if(config.__retryCount >= config.retry) {
		return Promise.reject(err)
	}
	//重试次数自增
	config.__retryCount += 1
	//延时处理
	var backoff = new Promise(function(resolve) {
		setTimeout(function() {
			resolve()
		}, config.retryDelay || 1)
	})
	//重新发起axios请求
	return backoff.then(function() {
		return axios(config)
	})
})
axios.install = (Vue) => {
	Vue.prototype.$axios = axios
}
export default axios



// WEBPACK FOOTER //
// ./src/assets/plug-in/http.js